<template>
	<article>
		<form @submit.prevent="search">
			<ManagingSection :column-count="2">
				<ManagingBox title="브랜드명">
					<input
						type="text"
						placeholder="브랜드명을 입력해주세요"
						v-model="brandName"
					/>
				</ManagingBox>
				<ManagingBox title="국가">
					<div class="brand__country">
						<SearchBrandCountry
							@change="getCountry"
							ref="brandCountry"
							placeholder="국가 찾기"
						/>
						<input
							type="text"
							readonly
							v-model="country"
							placeholder="국가를 선택해 주세요"
						/>
						<button
							v-if="country"
							type="text"
							class="btn bordered"
							@click="deleteCountry"
						>
							삭제
						</button>
					</div>
				</ManagingBox>
			</ManagingSection>
			<div class="btn-wrap-main">
				<button class="btn-main blue" type="submit">검색</button>
				<button
					class="btn-main blue bordered"
					type="button"
					@click="searchInit"
				>
					초기화
				</button>
			</div>
		</form>
		<ManagingSection :isTable="true">
			<template slot="infoSection">
				<p class="section__info__left">
					등록 : {{ total }}건 / 활성 : {{ isDisplayCnt }}건 / 비활성
					: {{ nonDisplayCnt }}건
				</p>
				<div class="section__info__right">
					<button
						class="btn-excel section__info__items"
						type="button"
						@click="openExcelModal"
					>
						엑셀 다운로드
					</button>
					<div class="section__info__items">
						<Selector
							:option-list="searchWordList"
							v-model="searchWord"
							@input="getList"
						/>
					</div>
					<div class="section__info__items">
						<Selector
							:option-list="sortList"
							v-model="sort"
							@input="getSortList"
						/>
					</div>
					<div class="section__info__items">
						<Selector
							:option-list="limitList"
							v-model="limit"
							@input="getList"
						/>
					</div>
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th>번호</th>
						<th>
							<SortLabel
								title="브랜드명"
								@change="changingSort"
								:propsValue="sortField[0].value"
								:id="sortField[0].id"
								:down="19"
								:up="20"
							/>
						</th>
						<th>브랜드명(보조)</th>
						<th>국가</th>
						<th>브랜드 카테고리</th>
						<th>
							<SortLabel
								title="등록일"
								@change="changingSort"
								:propsValue="sortField[1].value"
								:id="sortField[1].id"
								:down="1"
								:up="2"
							/>
						</th>
						<th>
							<SortLabel
								title="제품수"
								@change="changingSort"
								:propsValue="sortField[2].value"
								:id="sortField[2].id"
								:down="5"
								:up="6"
							/>
						</th>
						<th>
							<SortLabel
								title="로고"
								@change="changingSort"
								:propsValue="sortField[3].value"
								:id="sortField[3].id"
								:down="7"
								:up="8"
							/>
						</th>
						<th>
							<SortLabel
								title="홈페이지"
								@change="changingSort"
								:propsValue="sortField[4].value"
								:id="sortField[4].id"
								:down="9"
								:up="10"
							/>
						</th>
						<th>
							<SortLabel
								title="페이스북"
								@change="changingSort"
								:propsValue="sortField[5].value"
								:id="sortField[5].id"
								:down="11"
								:up="12"
							/>
						</th>
						<th>
							<SortLabel
								title="엑스"
								@change="changingSort"
								:propsValue="sortField[6].value"
								:id="sortField[6].id"
								:down="13"
								:up="14"
							/>
						</th>
						<th>
							<SortLabel
								title="카카오톡"
								@change="changingSort"
								:propsValue="sortField[7].value"
								:id="sortField[7].id"
								:down="15"
								:up="16"
							/>
						</th>
						<th>
							<SortLabel
								title="유튜브"
								@change="changingSort"
								:propsValue="sortField[8].value"
								:id="sortField[8].id"
								:down="17"
								:up="18"
							/>
						</th>
						<th>인스타그램</th>
						<th>
							<SortLabel
								title="리뷰수"
								@change="changingSort"
								:propsValue="sortField[10].value"
								:id="sortField[10].id"
								:down="21"
								:up="22"
							/>
						</th>
						<th>
							<SortLabel
								title="위시수"
								@change="changingSort"
								:propsValue="sortField[11].value"
								:id="sortField[11].id"
								:down="23"
								:up="24"
							/>
						</th>
						<th>연락처</th>
						<th>판매처 일괄 변경</th>
						<th>
							<SortLabel
								title="전시여부"
								@change="changingSort"
								:propsValue="sortField[9].value"
								:id="sortField[9].id"
								:down="3"
								:up="4"
							/>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="brand in brandList" :key="brand.idBrand">
						<td>{{ brand.idBrand }}</td>
						<td>
							<RouterLink
								class="link"
								:to="`/brand/${brand.idBrand}`"
								>{{ brand.name }}</RouterLink
							>
						</td>
						<td>{{ brand.subName || '-' }}</td>
						<td>{{ brand.country }}</td>
						<td>{{ brand.brandCategoryText || '-' }}</td>
						<td>{{ brand.createDate }}</td>
						<td>{{ brand.productCount }}</td>
						<td>{{ brand.hasLogo ? 'Y' : 'N' }}</td>
						<td>
							<a
								v-if="brand.brandUrl"
								:href="brand.brandUrl"
								target="__blank"
								class="brand__link"
								>o</a
							>
							<span v-else>X</span>
						</td>
						<td>
							<a
								v-if="brand.brandFacebook"
								:href="brand.brandFacebook"
								target="__blank"
								class="brand__link"
								>o</a
							>
							<span v-else>X</span>
						</td>
						<td>
							<a
								v-if="brand.twitter"
								:href="brand.twitter"
								target="__blank"
								class="brand__link"
								>o</a
							>
							<span v-else>X</span>
						</td>
						<td>
							<a
								v-if="brand.kakaotalk"
								:href="brand.kakaotalk"
								target="__blank"
								class="brand__link"
								>o</a
							>
							<span v-else>X</span>
						</td>
						<td>
							<a
								v-if="brand.youTube"
								:href="brand.youTube"
								target="__blank"
								class="brand__link"
								>o</a
							>
							<span v-else>X</span>
						</td>
						<td>
							<a
								v-if="brand.instagram"
								:href="brand.instagram"
								target="__blank"
								class="brand__link"
								>o</a
							>
							<span v-else>X</span>
						</td>
						<td>{{ brand.reviewCount }}</td>
						<td>{{ brand.wishCount }}</td>
						<td>{{ brand.tel }}</td>
						<td>
							<button
								class="btn blue"
								type="button"
								@click="
									openProductChangeModal(
										brand.name,
										brand.subName,
										brand.idBrand
									)
								"
							>
								판매처 변경
							</button>
						</td>
						<td>
							<p>{{ brand.isDisplay ? 'Y' : 'N' }}</p>
							<button
								:class="[
									'btn',
									brand.isDisplay ? 'bordered' : 'blue',
								]"
								type="button"
								@click="
									changeDisplay(
										brand.idBrand,
										brand.isDisplay
									)
								"
							>
								{{ brand.isDisplay ? '삭제' : '승인' }}
							</button>
						</td>
					</tr>
				</tbody>
			</table>
			<PaginationBox
				slot="pagination"
				:totalItem="total"
				:offset="offset"
				:limit="limit"
				@to="onPagination($event.offset)"
			/>
		</ManagingSection>
	</article>
</template>

<script>
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import SortLabel from '@/components/product/SortLabel.vue';
	import PaginationBox from '@/components/PaginationBox.vue';
	import Selector from '@/components/Selector.vue';
	import SearchBrandCountry from '../../components/SearchBrandCountry.vue';
	import moment from 'moment';

	export default {
		name: 'BrandList',
		components: {
			ManagingSection,
			ManagingBox,
			SortLabel,
			PaginationBox,
			Selector,
			SearchBrandCountry,
		},
		data() {
			return {
				searchWordList: [
					{ value: null, name: '이니셜' },
					{ value: 'ㄱ', name: 'ㄱ' },
					{ value: 'ㄴ', name: 'ㄴ' },
					{ value: 'ㄷ', name: 'ㄷ' },
					{ value: 'ㄹ', name: 'ㄹ' },
					{ value: 'ㅁ', name: 'ㅁ' },
					{ value: 'ㅂ', name: 'ㅂ' },
					{ value: 'ㅅ', name: 'ㅅ' },
					{ value: 'ㅇ', name: 'ㅇ' },
					{ value: 'ㅈ', name: 'ㅈ' },
					{ value: 'ㅊ', name: 'ㅊ' },
					{ value: 'ㅋ', name: 'ㅋ' },
					{ value: 'ㅌ', name: 'ㅌ' },
					{ value: 'ㅍ', name: 'ㅍ' },
					{ value: 'ㅎ', name: 'ㅎ' },
					{ value: 'a', name: 'a~z' },
					{ value: '0', name: '0~9' },
					{ value: 'etc', name: 'etc' },
				],
				searchWord: null,
				sortList: [
					{ value: 1, name: '최신등록순' },
					{ value: 2, name: '이전등록순' },
					{ value: 3, name: '전시순' },
					{ value: 4, name: '비전시순' },
					{ value: 5, name: '제품많은순' },
					{ value: 6, name: '제품적은순' },
					{ value: 7, name: '로고순' },
					{ value: 8, name: '미로고순' },
					{ value: 9, name: '홈페이지순' },
					{ value: 10, name: '비홈페이지순' },
					{ value: 11, name: '페이스북순' },
					{ value: 12, name: '비페이스북순' },
					{ value: 13, name: '엑스순' },
					{ value: 14, name: '비엑스순' },
					{ value: 15, name: '카카오톡순' },
					{ value: 16, name: '비카카오톡순' },
					{ value: 17, name: '유투브순' },
					{ value: 18, name: '비유투브순' },
					{ value: 19, name: '브랜드명순' },
					{ value: 20, name: '브랜드명역순' },
					{ value: 21, name: '리뷰수 많은순' },
					{ value: 22, name: '리뷰수 적은순' },
					{ value: 23, name: '위시 많은순' },
					{ value: 24, name: '위시 적은순' },
				],
				limitList: [
					{ value: 10, name: '10개씩' },
					{ value: 20, name: '20개씩' },
					{ value: 30, name: '30개씩' },
					{ value: 40, name: '40개씩' },
					{ value: 50, name: '50개씩' },
				],
				sort: 1,
				limit: 10,
				offset: 0,
				brandList: [],
				total: 0,
				brandName: '',
				country: '',
				isDisplayCnt: '',
				nonDisplayCnt: '',
				sortField: [
					{ id: 'brandName', value: null },
					{ id: 'createDate', value: null },
					{ id: 'productCount', value: null },
					{ id: 'hasLogo', value: null },
					{ id: 'brandUrl', value: null },
					{ id: 'brandFacebook', value: null },
					{ id: 'x', value: null },
					{ id: 'kakaotalk', value: null },
					{ id: 'youTube', value: null },
					{ id: 'isDisplay', value: null },
					{ id: 'reviewCount', value: null },
					{ id: 'wishCount', value: null },
				],
			};
		},

		created() {
			this.setFilter();
			this.getList();
		},
		async mounted() {
			await this.$store.dispatch('brandList/getStoreList');
		},
		watch: {
			country(newValue, oldValue) {
				if (newValue !== oldValue) {
					this.$refs.brandCountry.init();
				}
			},
			sortField(newList) {
				const key = 'order';
				let orderValue = null;
				const changeList = list => {
					for (let i = 0; i < list.length; i++) {
						const id = list[i].id;
						const value = list[i].value;
						if (value === true || value !== null) {
							switch (id) {
								case 'brandName':
									orderValue = value ? 19 : 20;
									break;
								case 'createDate':
									orderValue = value ? 1 : 2;
									break;
								case 'productCount':
									orderValue = value ? 5 : 6;
									break;
								case 'hasLogo':
									orderValue = value ? 7 : 8;
									break;
								case 'brandUrl':
									orderValue = value ? 9 : 10;
									break;
								case 'brandFacebook':
									orderValue = value ? 11 : 12;
									break;
								case 'x':
									orderValue = value ? 13 : 14;
									break;
								case 'kakaotalk':
									orderValue = value ? 15 : 16;
									break;
								case 'youTube':
									orderValue = value ? 17 : 18;
									break;
								case 'isDisplay':
									orderValue = value ? 3 : 4;
									break;
								case 'reviewCount':
									orderValue = value ? 21 : 22;
									break;
								case 'wishCount':
									orderValue = value ? 23 : 24;
									break;
							}
							return [
								{
									key,
									value: orderValue,
								},
							];
						}
					}
				};
				this.sort = changeList(newList)[0].value;
				this.getList();
			},
		},

		methods: {
			async getList() {
				const queryParams = this.getQueryParams().toString();
				const { data } = await this.$axiosAdmin2.get(
					`/api/brands/list?${queryParams}`
				);
				this.updateListData(data);
				this.setQuery();
			},
			getQueryParams() {
				const params = new URLSearchParams({
					offset: this.offset,
					limit: this.limit,
					searchWord: this.brandName,
					country: this.country,
					order: this.sort,
				});
				if (this.searchWord) {
					params.append('initial', this.searchWord);
				}
				return params;
			},

			updateListData(data) {
				this.total = data.total;
				this.nonDisplayCnt = data.nonDisplayCnt;
				this.isDisplayCnt = data.isDisplayCnt;
				this.brandList = data.data.map((brand, idx) => {
					return {
						...brand,
						createDate: this.convertDate(brand.createDate),
					};
				});
			},

			convertDate(date) {
				const trimString = date.slice(0, 8);
				return moment(trimString).format('YYYY-MM-DD');
			},
			onPagination(offset) {
				this.offset = offset;
				this.getList();
			},
			getCountry($event) {
				this.country = $event;
			},
			searchInit() {
				this.brandName = '';
				this.country = '';
				this.$refs.brandCountry.init();
			},
			deleteCountry() {
				this.country = '';
			},
			async changeDisplay(id, isDisplay) {
				if (isDisplay) {
					if (
						!confirm(
							'해당 브랜드의 모든제품이 일괄 비전시 처리가 됩니다. 정말 비활성처리 하시겠습니까?'
						)
					)
						return;
				} else {
					if (!confirm('정말 승인처리 하시겠습니까?')) return;
				}
				this.fetchDisplay(id);
			},
			async fetchDisplay(id) {
				try {
					await this.$axiosAdmin2.put(`/api/brands/display/${id}`);
					this.getList();
				} catch (err) {
					console.err(err);
					alert(
						'변경에 실패하였습니다. 지속적인 문제발생시 개발팀에 문의주세요.'
					);
				}
			},
			openProductChangeModal(name, subName, id) {
				this.$store.commit('modal/toggleModal', {
					id: 'BrandStoreChange',
				});
				this.$store.commit('brandList/setSelectedBrand', {
					name,
					subName,
					id,
				});
			},
			openExcelModal() {
				this.$store.commit('modal/toggleModal', {
					id: 'ExcelDownList',
					params: {
						total: this.total,
						type: 'brandList',
						params: {
							searchWord: this.brandName,
							country: this.country,
							order: this.sort,
							initial: this.searchWord,
						},
					},
				});
			},
			search() {
				this.getList();
			},

			getSortValue(id) {
				const field = this.sortField.find(item => item.id === id);
				return field ? field.value : null;
			},
			changingSort(changeList) {
				this.sortField = this.sortField.map(item => {
					let newVal = null;
					const isChanged = changeList.some(changes => {
						if (changes.id === item.id) {
							newVal = changes.newValue;
							return true;
						}
					});
					item.value = newVal;
					return item;
				});
			},
			getSortList() {
				this.sortField = this.sortField.map(item => {
					item.value = null;
					return item;
				});
				this.getList();
			},
			setQuery() {
				const query = {
					searchWord: this.brandName,
					country: this.country,
					order: this.sort,
					initial: this.searchWord,
					limit: this.limit,
					offset: this.offset,
				};
				const setQuery = Object.entries(query).reduce(
					(acc, [key, value]) => {
						if (value) {
							acc[key] = value;
						}
						return acc;
					},
					{}
				);

				this.$router.replace({ query: setQuery }).catch(() => {});
			},
			setFilter() {
				const query = this.$route.query;
				this.brandName = query.searchWord || '';
				this.country = query.country || '';
				this.sort = query.order || 1;
				this.searchWord = query.initial || null;
				this.limit = query.limit || 10;
				this.offset = query.offset || 0;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.brand {
		&__country {
			display: flex;
			align-items: center;
			gap: 5px;
		}
		&__link {
			color: #007bff;
			text-decoration: none;
			font-size: 18px;
		}
	}
</style>
